import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../services/firebase";
import "./CodingResult.css";

const CodingResult = ({ user }) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const local = localStorage.getItem("latestCodingResult");
    if (local) {
      setResult(JSON.parse(local));
    } else {
      const userKey = (user?.email || "guest").replace(/\./g, "_");
      const rRef = ref(db, `results/`);
      onValue(rRef, (snap) => {
        const all = snap.val();
        const userResults = Object.values(all || {}).filter(
          (r) =>
            r.user.replace(/\./g, "_") === userKey &&
            r.testType === "coding"
        );
        const latest = userResults.sort(
          (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt)
        )[0];
        if (latest) setResult(latest);
      });
    }
  }, [user]);

  if (!result) return <p>Loading result...</p>;

  return (
    <div className="coding-summary">
      <h2>✅ Coding Test Result</h2>
      <p><strong>Quiz:</strong> {result.quizTitle}</p>
      <p><strong>User:</strong> {result.user}</p>
      <p><strong>Submitted:</strong> {new Date(result.submittedAt).toLocaleString()}</p>
      {/* <p><strong>Duration:</strong> {result.duration}</p> */}
      <p><strong>Duration:</strong> {
        (() => {
          if (typeof result.duration === 'string' && result.duration.endsWith('sec')) {
            const sec = parseFloat(result.duration.replace(' sec', ''));
            const min = sec / 60;
            return min.toFixed(2) + ' min';
          }
          return result.duration;
        })()
      }</p>

      <h3>🎯 Score: {result.score} / {result.maxMarks}</h3>

      {result.answers.map((ans, idx) => (
        <div key={idx} className="code-result-card">
          <h4>Q{idx + 1}: {ans.question}</h4>
          <pre>{ans.code}</pre>
          <p><strong>Score:</strong> {ans.score} / {ans.maxMarks}</p>
          <ul>
            {(ans.testResults || []).map((tc, i) => (
              <li
                key={i}
                className={tc.passed ? "pass" : "fail"}
              >
                {tc.passed ? "✔️" : "❌"} | <strong>Input:</strong> <span className="tag">{tc.input}</span>
                {" "}| <strong>Expected:</strong> <span className="tag">{tc.expected}</span>
                {" "}| <strong>Output:</strong> <span className={`tag ${tc.passed ? "pass" : "fail"}`}>{tc.output}</span>
              </li>
            ))}
          </ul>

          {ans.logs && (
            <details>
              <summary>🔍 Debug Logs</summary>
              <ul>
                {ans.logs.map((log, j) => (
                  <li key={j} style={{ marginBottom: '1rem' }}>
                    <strong>Input:</strong> {log.input}<br />
                    {log.status_desc && <><strong>Status:</strong> {log.status_desc}<br /></>}
                    {log.status_id !== undefined && <><strong>Status Code:</strong> {log.status_id}<br /></>}
                    {log.error && <><strong>Error:</strong> {log.error}<br /></>}
                    {log.stderr && <><strong>stderr:</strong> {log.stderr}<br /></>}
                    {log.compile_output && <><strong>Compile Output:</strong> {log.compile_output}<br /></>}
                  </li>
                ))}
              </ul>
            </details>
          )}
        </div>
      ))}
      <button onClick={() => window.location.href = "/dashboard"}>🔙 Back to Dashboard</button>
    </div>
  );
};

export default CodingResult;
